import PropTypes from "prop-types";
import Modal from "../modal-new";
import copy from "clipboard-copy";
import { truncateText } from "../../utils/string-helpers";

export const ReferralLinkProgram = ({ activeUser }) => {
  const { link: referralLink = "" } = activeUser.referralProgramInfo || {};

  return (
    <Modal className="referral-link-modal" title={"Referral Link"}>
      <div className="body">
        <div className="revenue-container">
          <p className="title">Share & Earn 50% Revenue!</p>
          <p className="title mt-3 mb-1">
            Are you enjoying MyStrengthBook? Know others who would benefit from
            it too?
          </p>
          <p>
            Share MyStrengthBook with friends and colleagues, and you’ll earn
            50% of the revenue they generate for 6 months!
          </p>
        </div>

        <div className="referral-link-container">
          <p className="title my-3 opacity-70">Your Referral Link:</p>
          <div className="link-content">
            <a href={referralLink} target="_blank" rel="noopener noreferrer">
              {truncateText(referralLink, 57)}
            </a>
            <button
              data-button-type="secondary"
              data-icon
              data-icon-only
              onClick={async () => {
                await copy(referralLink);
              }}
            >
              <img src="/img/new-icons/copy.svg" />
            </button>
          </div>
          <p className="italic mb-3 opacity-70">
            Copy and share with your network.
          </p>
        </div>
        <BulletContent />
        <p className="title mt-4 opacity-70">
          Start sharing and help others while you earn!
        </p>
        <div className="mt-10 mb-8 justify-items-end">
          <a
            className="py-4 px-6 h-auto w-fit"
            target="_blank"
            rel="noopener noreferrer"
            href="https://mystrengthbook.firstpromoter.com/home"
            role="button"
            data-button-type="outline"
          >
            Dashboard
          </a>
        </div>
      </div>
    </Modal>
  );
};

ReferralLinkProgram.contextTypes = { activeUser: PropTypes.object };

const BulletContent = () => {
  const contentToDisplay = [
    "Share your link with anyone interested in taking their strength training to the next level.",
    "When they sign up and subscribe, you’ll earn 50% of the revenue they generate for 6 months.",
    "Get paid directly into your account",
  ];

  return (
    <div className="list-container">
      <p className="title mb-1">How It Works:</p>
      {contentToDisplay.map((text, index) => (
        <div key={index} className="mb-2">
          <span className="mr-2">{index + 1}.</span>
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
};
